import { appConfig, log } from '../config/env';
import type { WidgetConfig } from '../types/api';

/** Soft origin gate for host → panel postMessage (proposal §5.3). */
export function isTrustedHostMessage(
  origin: string,
  config: WidgetConfig | null,
): boolean {
  if (!origin || origin === 'null') return false;
  // Standalone / preview on the panel origin itself.
  if (origin === window.location.origin) return true;
  const allow = config?.allowlist?.origins;
  if (!allow || allow.length === 0) {
    // Before config loads, accept; Gateway still enforces allowlist on API.
    return true;
  }
  if (allow.includes(origin)) return true;
  // Dev proxy / harness often runs on an origin not yet allowlisted.
  if (appConfig.isDevelopment) return true;
  log('warn', 'Ignoring postMessage from origin not on allowlist', { origin });
  return false;
}

export function shouldAutoOpen(): boolean {
  const isEmbedded = window.parent !== window;
  const preview = new URLSearchParams(window.location.search).has('preview');
  return !isEmbedded || preview;
}
